function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2026 10.7307C20.2026 16.359 16.348 20.3644 10.6557 20.3644C5.198 20.3644 0.790476 15.9572 0.790476 10.5C0.790476 5.04278 5.19799 0.635622 10.6557 0.635622C13.3129 0.635622 15.5485 1.61012 17.2709 3.21707L14.5858 5.79851C11.0733 2.40962 4.54164 4.95526 4.54164 10.5C4.54164 13.9406 7.29037 16.7289 10.6557 16.7289C14.562 16.7289 16.0258 13.9287 16.2566 12.4768H10.6557V9.08398H20.0475C20.139 9.58913 20.2026 10.0744 20.2026 10.7307V10.7307Z",
  fill: "white"
});
function SvgGoogleG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleG);
export default __webpack_public_path__ + "static/media/google-g.252b7bfd0ac56fcb83533a26270b76f5.svg";
export { ForwardRef as ReactComponent };